import React from 'react';
import { BasicComponentProps } from '@whoop/web-components/dist/types';
import styles from './index.module.scss';

type FormErrorProps = {
  message: string;
} & BasicComponentProps;

function FormError({ message, ...props }: FormErrorProps) {
  return (
    <div className={styles.error} {...props}>
      {message}
    </div>
  );
}

export default FormError;
